import styled from "styled-components";

interface IButtonProps {
  size: number;
  disabled?: boolean;
  backgroundColor?: string;
  backgroundColorHover?: string;
}

export const Container = styled.button<IButtonProps>`
  border: none;
  border-radius: 50%;
  background-color: ${(props) => props.backgroundColor || "#fff"};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;

  :hover {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
    background-color: ${(props) => (props.disabled ? props.backgroundColor || "#fff" : props.backgroundColorHover || "#d0d2ea")};
  }

  :active {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
    background-color: ${(props) => props.backgroundColor || "#fff"};
  }
`;
